import ReplyWithTextFeatures from './contract/ReplyWithTextFeatures';
import './orchestrators/NewMessageV3Orchestrator';
import './orchestrators/onCreateFeedbackForCortana';
import { LazyAction, LazyModule } from 'owa-bundling';
import { ClientItemId } from 'owa-client-ids';
import { InstrumentationContext } from 'owa-mail-store';

export { default as datapoints } from './datapoints';
export { InstrumentationContext };
export { ClientItemId };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailMessageActions", webpackPrefetch: true */ './lazyIndex')
);

export let lazyNewMessage = new LazyAction(lazyModule, m => m.newMessage);
export let lazyReplyToConversation = new LazyAction(lazyModule, m => m.replyToConversation);
export let lazyForwardConversation = new LazyAction(lazyModule, m => m.forwardConversation);
export let lazyPrintConversation = new LazyAction(lazyModule, m => m.printConversation);
export let lazyReplyToItem = new LazyAction(lazyModule, m => m.replyToItem);
export let lazyForwardItem = new LazyAction(lazyModule, m => m.forwardItem);
export let lazyPrintItem = new LazyAction(lazyModule, m => m.printItem);
export let lazyShowConversationInImmersiveReader = new LazyAction(
    lazyModule,
    m => m.showConversationInImmersiveReader
);
export let lazyReplyWithText = new LazyAction(lazyModule, m => m.replyWithText);
export { ReplyWithTextFeatures };
